import { graphql } from "@/lib/gql/__generated__";

export const RefundRequestList_RefundRequestTopPage_Query = graphql(/* GraphQL */ `
	query RefundRequestList_RefundRequestTopPage($hotelID: ID!) {
		refundRequestList(hotelID: $hotelID) {
			id
			hotelID
			list {
				id
				hotelID
				reservationID
				uniqueID
				status
				refundRequestAmount
				refundRequestReason
				refundRejectReason
				guestName
				dateCin
				dateCout
				latestUpdatedAt
			}
		}
	}
`);
